(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recently-viewed"] && !window.DesignMode) return;
  try {
    
  const localViewed = localStorage.recentlyViewedProduct;

  function getRecentlyViewedProducts() {
    const productData = JSON.parse(localStorage.getItem('recentlyViewedProducts'));
    const fullContent = document.getElementById('recently-viewed-grid');
    const recentlyViewedHtml = [];
    const now = new Date();
    const nowTime = Math.floor(now.getTime() / 1000);

    if (productData === null || !fullContent) {
      document.querySelector('.recently-viewed-section').hidden = true;
      return;
    }

    productData.forEach((el, index) => {
      let section_url = el.productUrl + '?sections=recent-product-card';

      fetch(section_url)
        .then((response) => response.json())
        .then((json) => {
          let parsed = json['recent-product-card'];
          let html = new DOMParser().parseFromString(parsed, 'text/html');
          let productCards = html.getElementById('recent-card');
          // recentlyViewedHtml.unshift(productCards.innerHTML);
          fullContent.innerHTML += productCards.innerHTML;
        });
    });

    const newSwiper = new Moonbase.Swiper('#recently-viewed-swiper', {
      slidesPerView: 2.2,
      spaceBetween: 8,
      slidesOffsetBefore: 20,
      navigation: {
        nextEl: '.recently-viewed-swiper-button-next',
        prevEl: '.recently-viewed-swiper-button-prev',
        clickable: true,
      },
      pagination: {
        el: ".recently-viewed-pagination",
        type: "bullets"
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
          slidesOffsetBefore: 0
        },
      },
    });
  }

  //product recommendations/ymal

  function initYmalSwiper() {
    const ymalSwiper = new Moonbase.Swiper('#ymal-swiper', {
      slidesPerView: 2.2,
      spaceBetween: 8,
      slidesOffsetBefore: 20,
      navigation: {
        nextEl: '.ymal-swiper-button-next',
        prevEl: '.ymal-swiper-button-prev',
        clickable: true,
      },
      pagination: {
        el: ".ymal-pagination",
        type: "bullets"
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
          slidesOffsetBefore: 0
        },
      },
    });
  }

  function getYmalProducts() {
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          initYmalSwiper();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function observeYmalSection() {
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const config = {
      rootMargin: '0px 0px 200px 0px',
    };

    if (!productRecommendationsSection) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          getYmalProducts();
          observer.unobserve(productRecommendationsSection);
        }
      });
    }, config);

    observer.observe(productRecommendationsSection);
  }

  const toggleYmal = document.querySelector('.toggle_ymal');
  const toggleRecentlyViewed = document.querySelector('.toggle_recently_viewed');
  const ymalSwiper = document.querySelector('.ymal-swiper');
  const rvSwiper = document.querySelector('.recently-viewed-swiper');

  toggleYmal?.addEventListener('click', function (event) {
    toggleView();
  });

  toggleRecentlyViewed?.addEventListener('click', function (event) {
    toggleView();
  });

  if (ymalSwiper && !rvSwiper) {
    ymalSwiper.classList.remove('hidden');
  }

  function toggleView() {
    if (!ymalSwiper || !rvSwiper) {
      return;
    }

    ymalSwiper.classList.toggle('hidden');
    rvSwiper.classList.toggle('hidden');
    toggleYmal.classList.toggle('underline');
    toggleRecentlyViewed.classList.toggle('underline');
  }

  document.addEventListener('DOMContentLoaded', function (event) {
    getRecentlyViewedProducts();
    observeYmalSection();
  });

  } catch(e) { console.error(e); }
})();
})();
